<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Management</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-exam-setup @created="handleCreated"/>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Exam Select -->
          <div class="col-md-3 col-12 mb-2">
            <a-spin :spinning="examSpinning">
              <a-select
                size="large"
                v-model="selectedExam"
                placeholder="All Exams"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleExamSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Exams</a-select-option>
                <template v-for="schoolExam in schoolExams">
                  <a-select-option :value="schoolExam.id" :key="schoolExam.id">
                  {{schoolExam.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <exam-setup-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'

import ExamSetupTable from '@/components/exam/setup/Table/index'
import AddExamSetup from '@/components/exam/setup/Forms/Add/index'

export default {
  components: {
    ExamSetupTable,
    AddExamSetup,
  },
  mounted: function() {
    this.loadFromUrl()
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        if (!this.selectedSession) {
          this.selectedSession = find(data.data, ['is_current', 1]).id
        }
        this.getClasses()
        this.getExams()
      })
      .catch(error => {
        console.log(error)
      })
    this.getClassSectionExam()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      if (!this.$route.query.session_id) {
        this.selectedSession = val.id
      }
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      selectedSession: undefined,
      selectedClass: undefined,
      selectedExam: undefined,
      schoolSessions: [],
      schoolClasses: [],
      schoolExams: [],
      classSpinning: false,
      examSpinning: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  methods: {
    loadFromUrl() {
      const { session_id: sessionId, class_id: classId, exam_id: examId, page, limit } = this.$route.query
      if (sessionId) this.selectedSession = isNaN(parseInt(sessionId)) ? undefined : parseInt(sessionId)
      if (classId) this.selectedClass = isNaN(parseInt(classId)) ? undefined : parseInt(classId)
      if (examId) this.selectedExam = isNaN(parseInt(examId)) ? undefined : parseInt(examId)
      if (page) this.current = isNaN(parseInt(page)) ? 1 : parseInt(page)
      if (limit) this.pageSize = isNaN(parseInt(limit)) ? 30 : parseInt(limit)
    },
    syncToUrl() {
      const query = {
        ...this.$route.query,
        session_id: this.selectedSession,
        class_id: this.selectedClass,
        exam_id: this.selectedExam,
        page: this.current,
        limit: this.pageSize,
      }
      // Remove undefined/null values from query
      Object.keys(query).forEach(key => (query[key] === undefined || query[key] === null) && delete query[key])

      if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
        this.$router.replace({ query }).catch(() => {})
      }
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getExams() {
      this.examSpinning = true
      this.$http.get('/api/exam', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolExams = data.data
          this.examSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassSectionExam: function() {
      this.loading = true
      this.syncToUrl()
      this.$http.get('/api/classsectionexam', {
        params: {
          session_id: this.selectedSession,
          class_id: this.selectedClass,
          exam_id: this.selectedExam,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data.map(item => ({
          ...item,
          mark_entry_open: item.mark_entry_open === 1,
          remark_entry_open: item.remark_entry_open === 1,
        }))
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getClassSectionExam()
    },
    handleUpdateTable: function() {
      this.getClassSectionExam()
    },
    handleSessionChange (value) {
      this.selectedClass = undefined
      this.selectedExam = undefined
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession.id
      }
      this.getClasses()
      this.getExams()
      this.getClassSectionExam()
    },
    handleClassSelect(value) {
      this.selectedClass = value
      this.getClassSectionExam()
    },
    handleExamSelect(value) {
      this.selectedExam = value
      this.getClassSectionExam()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getClassSectionExam()
    },
    onChange(current) {
      this.current = current
      this.getClassSectionExam()
    },
  },
}
</script>
